import { useToast } from "@/hooks/use-toast";
import { useNavigate } from "react-router-dom";

export const useToastNavigate = (): { toast; navigate } => {
  const { toast } = useToast();
  const navigate = useNavigate();
  return {
    toast,
    navigate,
  };
};
